const i18n = require('@/lang/index')

module.exports = {
  info: {
    url: 'www.vtmarkets.com',
    urlGcn: 'www.vtmarketsglobal.com',
    urlCn: 'www.vtmarketstrade.com',
    urlTw: 'www.vtmarketsglobal.com/hk',
    urlId: 'www.vtmarketsid.com',
    urlEu: 'www.vtmarkets.net',
    urlIt: 'www.vtmarketsit.com',
    urlIr: 'www.vtmarkets-fa.com',
    urlIrPro: 'www.global-vtrader.com',
    // urlVn: 'www.vtmarketsvtnm.com',
    urlVn: 'www.vtmarketsvie.com',
    urlFrEu: 'www.vtmfr.com',
    urlMy: 'www.vtmarketsmy.com',
    urlRu: 'www.vtmarketsru.com',
    urlIraq: 'www.vglobaltrader.com',
    urlJa: 'www.vtmarketsjp.com',
    urlKh: 'www.vtmarketskh.com',
    map:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14973.672139712427!2d57.4952389!3d-20.2414905!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x217c5b485e823a99%3A0x664d7713ca9d6a73!2sThe%20Catalyst!5e0!3m2!1sen!2ssg!4v1699326487978!5m2!1sen!2ssg',
    mapIran:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.1570730181543!2d-61.2254683241286!3d13.152490387179643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c4751501a16f1a7%3A0x852ca13a834a3fd9!2sFirst%20St%20Vincent%20Bank!5e0!3m2!1sen!2smy!4v1709709585149!5m2!1sen!2smy',
    address: `<span>Level 2, Suite 201, The Catalyst, 40 Silicon Avenue</span><br>
      <span>Ebène</span><br>
      <span>Republic of Mauritius</span>`,
    addressIran: `<span>Euro House, Richmond Hill Road Kingstown VC0100,</span><br>
      <span>St. Vincent and the Grenadines</span>
    `,
    name: 'VT Markets Limited',
    nameIran: 'VT Markets LLC',
    email: 'info@vtmarkets.com',
    depositEmail: 'deposit@vtmarkets.com',
    withdrawalEmail: 'withdrawal@vtmarkets.com',
  },
  withdrawSetup: { checkMethodMinAmount: true, cancelWithdraw: true },
}
